function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import OlZoom from 'ol/control/Zoom';
import { useEffect, useMemo, useRef } from 'react';
var Minus = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC4yNDEiIGhlaWdodD0iMS43OCI+PHJlY3QgaWQ9Ik1pbnVzLVJlY3RhbmdsZSIgd2lkdGg9IjE0LjI0MSIgaGVpZ2h0PSIxLjc4IiByeD0iLjg5IiB0cmFuc2Zvcm09InJvdGF0ZSgxODAgNy4xMiAuODkpIiBmaWxsPSIjMGMyMDNkIi8+PC9zdmc+";
var Plus = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC4yNDEiIGhlaWdodD0iMTQuMjQxIj48ZyBpZD0iUGx1cy1Hcm91cF8zOTgwIiBkYXRhLW5hbWU9Ikdyb3VwIDM5ODAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMzMuMzEgLTY5MC44NjQpIiBmaWxsPSIjMGMyMDNkIj48cmVjdCBpZD0iUGx1cy1SZWN0YW5nbGUiIHdpZHRoPSIxNC4yNDEiIGhlaWdodD0iMS43OCIgcng9Ii44OSIgdHJhbnNmb3JtPSJyb3RhdGUoMTgwIDE3My43NzYgMzQ5LjQzOCkiLz48cmVjdCBpZD0iUGx1cy1SZWN0YW5nbGUtMiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUiIHdpZHRoPSIxNC4yNDEiIGhlaWdodD0iMS43OCIgcng9Ii44OSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDUyMi4zMjMgMTgyLjc4MikiLz48L2c+PC9zdmc+";
import { useOpenLayers } from '../openlayers-context';
import { createImgWithClassName, getOptions } from '../utils';

var getAttributionOptionsWithDefaults = options => {
  var zoomInLabel = createImgWithClassName(Plus, 'ol-zoom-in-label-override');
  var zoomOutLabel = createImgWithClassName(Minus, 'ol-zoom-out-label-override');
  zoomInLabel.alt = 'Zoom in';
  zoomOutLabel.alt = 'Zoom out';
  return _objectSpread({
    target: 'ol-controls-zoom-target',
    className: 'ol-zoom-override',
    zoomInLabel: zoomInLabel,
    zoomOutLabel: zoomOutLabel
  }, options);
};

var allZoomOptions = {
  duration: undefined,
  className: undefined,
  zoomInLabel: undefined,
  zoomOutLabel: undefined,
  zoomInTipLabel: undefined,
  zoomOutTipLabel: undefined,
  delta: undefined,
  target: undefined
};

var Zoom = props => {
  var {
    map
  } = useOpenLayers();
  var control = useRef();
  var memoizedOptions = useMemo(() => getOptions(Object.assign(allZoomOptions, props)), [props]);
  var memoizedZoomDefaultOptions = useMemo(() => getAttributionOptionsWithDefaults(memoizedOptions), [memoizedOptions]);
  useEffect(() => {
    if (!map) return;
    control.current = new OlZoom(memoizedZoomDefaultOptions);
    map.addControl(control.current);
    return () => {
      if (control.current) map.removeControl(control.current);
    };
  }, [map, memoizedZoomDefaultOptions]);
  return null;
};

export default Zoom;